import { render, staticRenderFns } from "./stepProcess.vue?vue&type=template&id=0cf0593a&scoped=true"
import script from "./stepProcess.vue?vue&type=script&lang=js"
export * from "./stepProcess.vue?vue&type=script&lang=js"
import style0 from "./stepProcess.vue?vue&type=style&index=0&id=0cf0593a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0593a",
  null
  
)

export default component.exports